import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client";

const DEPARTMENTS = ["Finance", "Development", "CAM", "Engineering", "Program Management", "Operations"];

export default function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", department: "", password: "", confirm: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    setError("");
    if (!form.name || !form.email || !form.department || !form.password || !form.confirm)
      return setError("All fields are required.");
    if (form.password !== form.confirm)
      return setError("Passwords do not match.");
    if (form.password.length < 6)
      return setError("Password must be at least 6 characters.");
    setLoading(true);
    try {
      await api.post("/api/auth/register", {
        name: form.name,
        email: form.email,
        department: form.department,
        password: form.password,
        role: "viewer",
      });
      setSubmitted(true);
    } catch (e: any) {
      setError(e.response?.data?.detail || "Failed to submit request.");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6"><div className="flex w-full rounded-2xl overflow-hidden shadow-2xl" style={{ minHeight: "calc(100vh - 48px)" }}>
      <div className="hidden md:flex w-[55%] flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundColor: "#1d4ed8" }} />
        <img src="/plane.png" alt="Aircraft" className="absolute"
          style={{ bottom: "-5%", left: "50%", transform: "translateX(-50%) scaleX(-1)", width: "75%", objectFit: "contain", opacity: 0.92 }} />
        <div className="relative z-10 flex flex-col h-full p-10">
          <div className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-lg flex items-center justify-center border border-white border-opacity-40">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div>
              <p className="text-white text-xs font-medium tracking-wide" style={{ opacity: 0.8 }}>Collins Aerospace</p>
              <p className="text-white font-bold text-sm">EAC Reporting</p>
            </div>
          </div>
          <div className="flex-1 flex items-center">
            <h1 className="text-4xl font-bold text-white leading-tight mb-4">
              Earned Value<br />AI-Powered<br />Reporting
            </h1>
            <p className="text-blue-100 text-sm leading-relaxed max-w-xs">
              
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-8 py-10 bg-white">
        <div className="w-full max-w-sm">
          {!submitted ? (
            <>
              <div className="mb-7">
                <h2 className="text-2xl font-bold text-gray-900">Create an account</h2>
                <p className="text-sm text-gray-400 mt-1">Request access to the EAC Reporting workspace.</p>
              </div>
              <div className="space-y-4">
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Full Name</label>
                  <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                    placeholder="e.g. Sarah Chen"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Email address</label>
                  <div className="relative">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                    <input value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                      placeholder="sarah.chen@collinsaero.com" type="email"
                      className="w-full pl-10 pr-3 border border-gray-200 rounded-lg py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Department</label>
                  <select value={form.department} onChange={e => setForm(f => ({ ...f, department: e.target.value }))}
                    className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                    <option value="">Select your department</option>
                    {DEPARTMENTS.map(d => <option key={d}>{d}</option>)}
                  </select>
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Password</label>
                  <div className="relative">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <input type={showPassword ? "text" : "password"} value={form.password}
                      onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                      placeholder="Enter your password"
                      className="w-full pl-10 pr-10 border border-gray-200 rounded-lg py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button type="button" onClick={() => setShowPassword(p => !p)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400 hover:text-gray-600">
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
                <div>
                  <label className="text-xs font-medium text-gray-600 block mb-1">Confirm Password</label>
                  <div className="relative">
                    <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                    <input type={showConfirm ? "text" : "password"} value={form.confirm}
                      onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))}
                      placeholder="Re-enter your password"
                      className="w-full pl-10 pr-10 border border-gray-200 rounded-lg py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <button type="button" onClick={() => setShowConfirm(p => !p)}
                      className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-400 hover:text-gray-600">
                      {showConfirm ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
                {error && (
                  <div className="flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                    <svg className="w-4 h-4 text-red-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <p className="text-xs text-red-600">{error}</p>
                  </div>
                )}
                <button onClick={handleSubmit} disabled={loading}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg py-2.5 text-sm font-semibold transition-colors disabled:opacity-50">
                  {loading ? "Submitting..." : "Request Access →"}
                </button>
              </div>
              <p className="text-xs text-gray-400 text-center mt-5">
                Already have an account?{" "}
                <button onClick={() => navigate("/login")} className="text-blue-600 hover:underline font-medium">Sign in</button>
              </p>
            </>
          ) : (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-5">
                <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">Request Submitted</h2>
              <p className="text-sm text-gray-500 mb-1">Your access request has been sent to the workspace administrator.</p>
              <p className="text-sm text-gray-500 mb-6">You will receive an email once your account is approved and activated.</p>
              <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 text-left mb-6">
                <p className="text-xs text-gray-400 uppercase tracking-wide mb-2">Submitted as</p>
                <p className="text-sm font-semibold text-gray-800">{form.name}</p>
                <p className="text-xs text-gray-500">{form.email}</p>
                <p className="text-xs text-gray-500 mt-0.5">{form.department}</p>
              </div>
              <button onClick={() => navigate("/login")}
                className="w-full border border-gray-200 rounded-lg py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors">
                Back to Sign In
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
  );
}
